import { render, staticRenderFns } from "./LegalMentions.vue?vue&type=template&id=5aa81df8&scoped=true&"
import script from "./LegalMentions.vue?vue&type=script&lang=ts&"
export * from "./LegalMentions.vue?vue&type=script&lang=ts&"
import style0 from "./LegalMentions.vue?vue&type=style&index=0&id=5aa81df8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa81df8",
  null
  
)

export default component.exports